import { useTranslate } from '@repo/shared/hooks'
import { EMAIL_REGEX, isValidMobile, PASSWORD_REGEX } from '@repo/ui/lib'
import { z } from 'zod'

export const useLoginSchema = () => {
  const { t } = useTranslate()
  const mobileSchema = z.object({
    mobile: z
      .string({
        message: t('loginPage_validation_mobile_numbersOnly'),
      })
      .superRefine((val, ctx) => {
        if (!val.startsWith('09')) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_startWith09'),
          })
        }
        if (val && val.length !== 11) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_length'),
          })
          return
        }
        if (!isValidMobile(val)) {
          ctx.addIssue({
            code: z.ZodIssueCode.custom,
            message: t('loginPage_validation_mobile_numbersOnly'),
          })
        }
      }),
  })

  const emailSchema = z.object({
    email: z
      .string({
        message: t('registerPage_validation_email_required'),
      })
      .email({
        message: t('registerPage_validation_email_invalid'),
      })
      .regex(EMAIL_REGEX, {
        message: t('registerPage_validation_email_invalid'),
      }),
  })

  const passwordSchema = z.object({
    password: z
      .string({
        message: t('loginPage_validation_password_required'),
      })
      .min(6, {
        message: t('loginPage_validation_password_minLength'),
      }),
  })

  const identifierSchema = z.object({
    identifier: z
      .string({
        message: t('loginPage_validation_mobile_email_required'),
      })
      .superRefine((val, ctx) => {
        const isEmail = /[^0-9۰-۹٠-٩]/.test(val)
        if (isEmail) {
          const result = emailSchema.safeParse({ email: val })
          if (!result.success) {
            result.error.errors.forEach((err) => {
              ctx.addIssue({
                code: z.ZodIssueCode.custom,
                message: err.message,
              })
            })
          }
        } else {
          if (!val.startsWith('09')) {
            ctx.addIssue({
              code: z.ZodIssueCode.custom,
              message: t('loginPage_validation_mobile_startWith09'),
            })
          }
          if (!isValidMobile(val)) {
            const result = mobileSchema.safeParse({ mobile: val })
            if (!result.success) {
              result.error.errors.forEach((err) => {
                ctx.addIssue({
                  code: z.ZodIssueCode.custom,
                  message: err.message,
                })
              })
            }
          }
        }
      }),
  })

  return { mobileSchema, emailSchema, passwordSchema, identifierSchema }
}
